import { Component, OnInit, Input, EventEmitter, Output, OnDestroy } from '@angular/core';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'app-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss']
})
export class DatePickerComponent implements OnInit, OnDestroy {

  @Input() model: any;
  @Input() placeholder: string;
  @Input() disable = false;
  @Input() isRequired = false;
  @Input() floatLabel = 'auto';
  @Input() setMinDate: Observable<any>;
  @Output() sendData = new EventEmitter<any>();
  private subscriptions: Array<Subscription> = [];
  private minDate: Date | null = null;

  constructor() {}

  ngOnInit() {
    if (this.setMinDate) {
      this.subscriptions.push(this.setMinDate.subscribe(ev => this.minDate = ev ));
    }
  }

  onChange(ev) {
    this.sendData.emit(this.model);
  }

  clear() {
    this.model = null;
    this.sendData.emit(this.model);
  }

  get minStartDate(): Date | null {
    return this.minDate;
  }

  ngOnDestroy() {
    for (const subs of this.subscriptions) {
      subs.unsubscribe();
    }
  }

}
